import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from './environments/environment';
import './app/core/ag-grid/ag-grid-setup';
import 'hammerjs';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (window.location.href.includes('login/callback')) {
  const accessToken = window.location.hash.split('#access_token=')[1];
  localStorage.setItem('access_token', accessToken);
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
